import { Component } from '@theme/component';

class SimucubeCardSpecsToggle extends Component {
  requiredRefs = ['button'];

  #card = null;

  connectedCallback() {
    super.connectedCallback();
    this.#card = this.closest('product-card');
    this.refs.button.addEventListener('click', this.#toggle);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.button?.removeEventListener('click', this.#toggle);
  }

  #toggle = (event) => {
    event.preventDefault();

    if (!this.#card) return;

    const content = this.#card.querySelector('.product-card__content');
    const willOpen = !this.#card.hasAttribute('data-specs-open');

    if (content instanceof HTMLElement) {
      content.style.minHeight = willOpen ? `${content.getBoundingClientRect().height}px` : '';
    }

    const open = this.#card.toggleAttribute('data-specs-open');
    this.refs.button.setAttribute('aria-expanded', String(open));
  };
}

if (!customElements.get('simucube-card-specs-toggle')) {
  customElements.define('simucube-card-specs-toggle', SimucubeCardSpecsToggle);
}
